/* AWOL · ENTRADA
   La entrada alterna entre visitas: quien llega ve un video y la siguiente
   vez ve el otro. Los dos están en la página; aquí se decide cuál corre. */
document.querySelectorAll('[data-awol-video-reel]').forEach(function (raiz) {
  var videos = Array.prototype.slice.call(raiz.querySelectorAll('video.awol-entrada__video'));
  if (!videos.length) return;

  /* Cuál toca esta visita. Se alterna llevando la cuenta en el navegador:
     el servidor no sirve para esto porque Shopify guarda la página en caché
     y el sorteo se quedaría congelado para todo el mundo. Sin almacenamiento
     —ventana privada, cookies bloqueadas— se echa a la suerte, que al menos
     reparte. */
  var CLAVE = 'awol:entrada';
  var turno = 0;

  if (videos.length > 1) {
    try {
      var previo = parseInt(window.localStorage.getItem(CLAVE), 10);
      turno = isNaN(previo) ? 0 : (previo + 1) % videos.length;
      window.localStorage.setItem(CLAVE, String(turno));
    } catch (e) {
      turno = Math.floor(Math.random() * videos.length);
    }
  }

  videos.forEach(function (video, i) {
    video.muted = true;
    if (i === turno) {
      video.setAttribute('data-activo', '');
      video.preload = 'auto';
      var arranque = video.play();
      if (arranque && arranque.catch) arranque.catch(function () {});
    } else {
      video.removeAttribute('data-activo');
      video.pause();
    }
  });

  var alAire = videos[turno];

  /* El sonido entra mudo y así se queda hasta que alguien lo pida: es una
     decisión del que mira, no una emboscada al hacer scroll. */
  var boton = raiz.querySelector('[data-awol-sound-toggle]');
  if (boton) {
    var texto = boton.querySelector('[data-awol-sonido-texto]');

    var pintar = function () {
      var mudo = alAire.muted;
      boton.setAttribute('aria-pressed', String(!mudo));
      boton.setAttribute('aria-label', mudo ? 'Activar sonido' : 'Silenciar');
      if (texto) texto.textContent = mudo ? 'Sonido' : 'Silencio';
    };

    boton.addEventListener('click', function () {
      alAire.muted = !alAire.muted;
      if (!alAire.muted && alAire.paused) alAire.play().catch(function () {});
      pintar();
    });

    pintar();
  }

  /* Fuera de cuadro no hay por qué seguir decodificando. */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting) {
            alAire.play().catch(function () {});
          } else {
            alAire.pause();
          }
        });
      },
      { threshold: 0.1 }
    ).observe(raiz);
  }
});

/* El descenso al índice, suave y sin salto de ancla. */
document.querySelectorAll('[data-awol-baja]').forEach(function (enlace) {
  enlace.addEventListener('click', function (evento) {
    var destino = document.querySelector(enlace.getAttribute('href'));
    if (!destino) return;
    evento.preventDefault();
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

/* El reloj de la entrada. Hora de la zona que diga la sección, en formato
   de 24 horas: el navegador la calcula, así que no depende de en qué huso
   esté quien mira ni de cuándo se guardó la página en caché. */
document.querySelectorAll('[data-awol-reloj]').forEach(function (reloj) {
  var zona = reloj.getAttribute('data-zona') || 'America/Monterrey';
  var formato;

  try {
    formato = new Intl.DateTimeFormat('es-MX', {
      timeZone: zona,
      hourCycle: 'h23',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch (e) {
    /* zona inválida: se queda la hora que imprimió el servidor */
    return;
  }

  var pintar = function () {
    var hora = formato.format(new Date());
    reloj.textContent = hora;
    reloj.setAttribute('datetime', hora);
  };

  pintar();
  setInterval(pintar, 1000);
});
